@if (showConfirmation()) {
<div class="reservation-confirmation-container">
  <div class="summary-section">
    <ambassador-calendar-summary [idSchedule]="idSchedule()" [timePreference]="timePreference()" [idVehicle]="idVehicle" [showActions]="false">
    </ambassador-calendar-summary>
  </div>
  <ambassador-reservation-confirmation (confirmationStateChange)="onConfirmationStateChange($event)">
  </ambassador-reservation-confirmation>
</div>
} @else if (showForm()) {
<div class="reservation-form-container">
  <div class="summary-section">
    <ambassador-calendar-summary [idSchedule]="idSchedule()" [timePreference]="timePreference()" [idVehicle]="idVehicle" [showActions]="false">
    </ambassador-calendar-summary>
  </div>
  <div class="form-section">
    <ambassador-reservation-form [idSchedule]="idSchedule()" [timePreference]="timePreference()" [idVehicle]="idVehicle" (backToSummary)="showForm.set(false)" (reservationCompleted)="onReservationCompleted()">
    </ambassador-reservation-form>
  </div>
</div>
} @else if (showSummary()) {
<div class="reservation-summary-container">
  <ambassador-calendar-summary [idSchedule]="idSchedule()" [timePreference]="timePreference()" [idVehicle]="idVehicle" (backToCalendar)="onBackToCalendar()" (confirmReservation)="onConfirmReservation()">
  </ambassador-calendar-summary>
</div>
} @else {
<div class="reservation-calendar-container">
  <ambassador-calendar [idVehicle]="idVehicle" (reservationRequested)="onReservationRequested($event)">
  </ambassador-calendar>
</div>
}
